import { render } from "./CategoryBreadcrumb.vue?vue&type=template&id=46208341&lang=pug"
import script from "./CategoryBreadcrumb.vue?vue&type=script&lang=js"
export * from "./CategoryBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__